import PropTypes from 'prop-types';

export const titleShape = PropTypes.shape({
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
});

export const subtitleShape = PropTypes.shape({
  text: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
});

export const sectionShape = PropTypes.shape({
  title: titleShape.isRequired,
  subtitles: PropTypes.arrayOf(subtitleShape).isRequired,
});

export const vehicleReservationDataShape = PropTypes.shape({
  title: PropTypes.shape({
    text: PropTypes.string,
    color: PropTypes.string,
  }),
  subtitles: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string,
      color: PropTypes.string,
    }),
  ),
  action: PropTypes.shape({
    target: PropTypes.string,
    label: PropTypes.shape({
      text: PropTypes.string,
      color: PropTypes.string,
      font_size: PropTypes.string,
      font_family: PropTypes.string,
      text_icon: PropTypes.shape({
        id: PropTypes.string,
        color: PropTypes.string,
        alignment: PropTypes.string,
      }),
    }),
    disabled: PropTypes.bool,
    action_type: PropTypes.string,
  }),
});
